// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_k2d","cls2":"BulkFollowListModal-cls2__RX BulkFollowListModal-cls1_k2d"};